export const zoneFencesUrl = 'zone-fences/';
export const publicZoneFencesUrl = (shareLinkId: string) => `external/share-link/${shareLinkId}/zone-fences/`;
